import { Check } from '@mui/icons-material';
import { Box, Chip, Typography } from '@mui/material';
import moment from 'moment';

const Endereco = ({ endereco, tipo, picking }) => (
  <Box display="flex" flex={1} alignItems="center">
    <Box display="flex" flex={1} flexDirection="column">
      <Typography variant="body2">{endereco || ''}</Typography>
      <Typography variant="caption" color="grey">
        {tipo || ''}
      </Typography>
    </Box>
    {picking === 'SIM' && (
      <Chip
        size="small"
        label="Picking"
        variant="outlined"
        color="success"
        icon={<Check />}
      />
    )}
  </Box>
);

const Line = ({ label = '', value = '', large }) => (
  <Box display="flex" flex={1}>
    <Typography variant="caption" fontWeight="bold" color="grey" flex={1}>
      {label}:
    </Typography>
    <Typography variant="caption" color="grey" flex={large ? 3 : 1}>
      {value || '-'}
    </Typography>
  </Box>
);

const mock = [
  {
    field: 'endereco',
    renderCell: ({ row }) => (
      <Endereco
        tipo={row?.tipo}
        picking={row?.picking}
        endereco={row?.endereco}
      />
    ),
  },
  {
    field: 'endereco1',
    renderCell: ({ row }) => (
      <Endereco
        tipo={row?.tipo1}
        picking={row?.picking1}
        endereco={row?.endereco1}
      />
    ),
  },
  {
    field: 'endereco2',
    renderCell: ({ row }) => (
      <Endereco
        tipo={row?.tipo2}
        picking={row?.picking2}
        endereco={row?.endereco2}
      />
    ),
  },
  {
    field: 'produto',
    renderCell: ({ row }) => (
      <Box display="flex" flex={1} flexDirection="column">
        <Typography variant="body2" fontWeight="bold" mb={1}>
          {row?.produto}
        </Typography>
        <Box display="flex">
          <Line label="Referência" value={row?.referencia} />
          <Line label="Variação" value={row?.variacao} />
        </Box>
        <Box display="flex">
          <Line label="Rastreabilidade" value={row?.rastreabilidade} />
          <Line
            label="Validade"
            value={row?.validade && moment(row?.validade).format('DD/MM/YYYY')}
          />
        </Box>
        <Box display="flex">
          <Line label="Proprietário" value={row?.entidade} large />
        </Box>
      </Box>
    ),
  },
  {
    field: 'quantidade',
    valueGetter: ({ row }) => `${row?.quantidade || 0} ${row?.um || ''}`,
  },
];

export default mock;
